import { CASE_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: CASE_MNG,
  relationSearch: true,
  allowStatus: {},
  toolbar: {
    moreBtnWidth: 160,
    hasColAdjustment: true,
    items: []
  },
  view: {
    columns: [
      {
        props: {
          type: 'selection', // 包括 selection、radio、index等类型
          width: 55
        }
      },
      {
        props: {
          label: 'driverMng.driverTable.ip',
          prop: 'name',
          sortField: 'name'
        }
      },
      {
        //操作
        props: {
          showBtnNum: '1'
        },
        dataType: 'operation'
      }
    ],
    menus: []
  }
}
